import { Typography } from "antd";
import { TasksList } from "entities/tasks";
import { useTranslation } from "react-i18next";

export const TasksPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography.Title level={1}>{t("tasks.title")}</Typography.Title>
      <Typography.Text
        style={{
          fontSize: 16,
          marginBottom: 24,
          display: "block",
          color: "var(--color-grey)",
        }}
      >
        {t("tasks.sub_title")}
      </Typography.Text>

      <TasksList />
    </div>
  );
};
